import * as React from "react"
import { Step, BookingFlow } from "../../BookingFlow"
import { observable, computed, action } from "mobx"
import { SessionEditor } from "./SessionEditor"
import { BookingDB } from "../../db/BookingLightDB"
import { Modal } from "BookingSystem/utils/ModalComponents/Modal"
import { SessionCard } from "./PassesStepComp"
import { SessionType } from "BookingSystem/db/SessionType"
import { SessionGroup } from "BookingSystem/db/SessionGroup"

export class PassesStep implements Step {
  constructor(db: BookingDB, flow: BookingFlow) {
    this.db = db
    this.flow = flow
  }

  componentDidMount() {
    this.flow.watchTodaysSessions()
  }

  @computed
  get activityPlan() {
    return this.flow.currentBooking.activityPlan
  }

  componentWillUnMount() {
    this.flow.unWatchTodaysSessions()
  }

  @observable
  flow: BookingFlow

  @observable
  db: BookingDB

  name = "Passes"
  instruction = "Add passes for each member of your group"
  help = "Passes are non-refundable and non-transferable"

  button1Text = "Jump Mo Pass"
  button2Text = "Climb Mo Pass"
  button3Text = "Play Mo Pass"
  button4Text = "Observe Mo Pass"

  @action.bound
  addPass(sessionType: SessionType) {
    const nextAvailableSession = this.flow.currentBooking.nextAvailableSession(
      sessionType
    )

    if (!nextAvailableSession) {
      alert("Sorry no available sessions with capacity left for today")
    } else {
      const sessionGroup = new SessionGroup(
        this.db,
        SessionGroup.$create(
          this.flow.currentBooking.id,
          nextAvailableSession.id
        )
      )
      this.flow.showModal(() => this.showSessionEditorModal(sessionGroup))
    }
  }

  showSessionEditorModal(sessionGroup: SessionGroup) {
    const modal = new Modal(
      this.flow,
      action(() => {
        this.db.save(sessionGroup)
        this.flow.currentBooking.currentOrder.addSessionGroup(sessionGroup)
        this.flow.currentBooking.currentOrder.saveSessions()
      })
    )

    modal.title = "Pick time and members"
    modal.primaryButtonText = "Add session"
    modal.primaryDisabled = false
    modal.children = React.createElement(SessionCard, {
      model: new SessionEditor(this.db, this.flow, sessionGroup)
    })
    return modal
  }
}
